type Props = {
  isOn: boolean
}

// Requires a position:relative parent
export const Ping = ({
  isOn
}: Props) => {
  return <>
	{isOn && <div className="ping absolute top-0 bottom-0 border-[3px] dark:opacity-20 dark:border-white border-blue-500 pointer-events-none">
  	</div>}
	</>
}
